import React from "react";
import moment from "moment";
import {
  Container,
  ItemDetails,
  Left,
  Middle,
  Right,
  Details,
  IconInformation,
  Legend
} from "./styles";
import information from "~/assets/images/information.svg";

export default function Item({options, data, openModal}) {

  return (
    <Container className="mb-3">
      <Left>
        <Legend>
            Solicitação {data.code}
        </Legend>
        <ItemDetails>
          <span
            style={{
              fontSize: "10px",
              color:
              data.status === "Aceita"
                  ? "#75B943"
                  : data.status === "Negada"
                  ? "#e34e2a"
                  : data.status === "Em Análise"
                  ? "#f0b01b"
                  : "#000",
            }}
            className="mdi mdi-checkbox-blank-circle mr-1"
          />
          {data.status}
        </ItemDetails>
      </Left>

      <Middle>
        <ItemDetails>
          {data.date && (
            <>
              <Legend>Data:</Legend>{" "}
              { moment(data.date).format("DD/MM/YYYY") }
            </>
          )}
        </ItemDetails>
      </Middle>

      <Right>
        { data.schedule && (
          <Legend>
            Horário: {data.schedule}
          </Legend>
        )}
        { data.status === "Aceita" ? (
          <Legend>
            {(options && data.object) ? (options.find((item) => item.value === data.object)?.label || data.object ) : data.object }
          </Legend>
        ) : (
            <Details onClick={() => openModal()}>
              Detalhes
              <img src={information} style={IconInformation} alt=""/>
            </Details>
        )}
      </Right>
    </Container>
  );
}
